import React from 'react';
import Button from 'tailwind-components/Button';
import { X } from 'lucide-react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

export default function SidebarHeader({ sidebarTitle, closeSheet, className }) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-2 shrink-0 p-4 border-b border-grey-lighter',
        className
      )}
    >
      {sidebarTitle && (
        <h3 className='text-xl font-bold m-0 leading-none'>{sidebarTitle}</h3>
      )}
      <Button
        variant='transparent'
        type='button'
        onClick={closeSheet}
        aria-label='Close sidebar'
        icon={<X className='size-6' aria-hidden />}
      />
    </div>
  );
}

SidebarHeader.propTypes = {
  sidebarTitle: propTypes.string,
  closeSheet: propTypes.func,
  className: propTypes.string
};
